import { httpGetTransaction } from "api/vendor/transactions";
import Container from "components/layout/Container";
import Main from "components/layout/Main";
import VendorNav from "components/layout/VendorNav";
import VendorSidebar from "components/layout/VendorSidebar";
import VButton from "components/ui/VButton";
import useAsync from "hooks/useAsync";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { vendorRoutes } from "routes/routes";
import currency, { moneyFormat } from "utilities/currency";
import { showSuccess } from "utilities/misc";
import { post } from "utilities/network";

const DepositItem: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [transaction, setTransaction] = useState<any>({});

  const {
    execute: confirmTransaction,
    status,
    value,
  } = useAsync(
    () => post(`vendor/transactions/confirm/${params?.item}`, {}),
    false
  );

  const {
    execute: cancelTransaction,
    status: status2,
    value: value2,
  } = useAsync(
    () => post(`vendor/transactions/cancel/${params?.item}`, {}),
    false
  );

  const handleSubmit = () => {
    confirmTransaction();
  };
  const handleSubmit2 = () => {
    cancelTransaction();
  };

  useEffect(() => {
    if (value?.data?.success) {
      showSuccess("Transaction completed");
      navigate(vendorRoutes.dashboard);
    }
  }, [value, navigate]);

  useEffect(() => {
    if (value2?.data?.success) {
      showSuccess("Transaction cancelled");
      navigate(vendorRoutes.dashboard);
    }
  }, [value2, navigate]);

  useEffect(() => {
    if (!params.item) {
      return navigate(vendorRoutes.deposits);
    }
  }, [params?.item, navigate]);

  const getTransaction = async () => {
    let tr = await httpGetTransaction(params?.item);
    if (!tr.transaction) {
      return navigate(vendorRoutes.deposits);
    }
    setTransaction(tr.transaction);
  };

  useEffect(() => {
    getTransaction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const {
  //   data: { transaction },
  // } = useQuery(
  //   ["depositTransaction", params?.item],
  //   () => httpGetTransaction(params?.item),
  //   {
  //     initialData: { transaction: {} },
  //     onSuccess: (data) => {
  //       if (!data.transaction) {
  //         return navigate(vendorRoutes.deposits);
  //       }
  //     },
  //   }
  // );

  const bank =
    transaction?.address && transaction?.address !== "sell.bitoshi.africa"
      ? JSON.parse(transaction.address)
      : {};

  return (
    <Container isVendor>
      <VendorSidebar />

      <Main isVendor>
        <VendorNav
          title={`${currency("ngn")}${moneyFormat(
            transaction?.place === "external"
              ? Number(transaction.amount)
              : Number(transaction.amount) - Number(transaction.fee)
          )}`}
        />

        <div className="mt-10">
          <div className="px-5 py-5 mt-5 border border-black rounded-lg">
            {transaction?.place === "external" ? (
              <span className="px-1 text-xs bg-orange-300 rounded">
                sell.bitoshi.africa
              </span>
            ) : (
              ""
            )}
            <h4 className="mb-5 text-left">Account Details</h4>

            <div className="flex justify-between mb-5">
              <h5 className="text-sm font-light text-black text-opacity-60">
                Bank Name
              </h5>
              <p className="text-sm">{bank.bankName}</p>
            </div>
            <div className="flex justify-between mb-5">
              <h5 className="text-sm font-light text-black text-opacity-60">
                Account Number
              </h5>
              <p className="text-sm">{bank.accountNumber}</p>
            </div>
            <div className="flex justify-between mb-5">
              <h5 className="text-sm font-light text-black text-opacity-60">
                Account Name
              </h5>
              <p className="">{bank.accountName}</p>
            </div>
          </div>
          <div className="mt-10">
            <VButton
              onClick={handleSubmit}
              status={status}
              className="w-full py-4 text-white bg-orange-300"
            >
              Payment Completed
            </VButton>

            {transaction?.status === "pending" && (
              <VButton
                onClick={handleSubmit2}
                status={status2}
                className="w-full py-4 mt-4 text-orange-300 bg-transparent border border-orange-200"
              >
                Cancel
              </VButton>
            )}
          </div>
        </div>
      </Main>
    </Container>
  );
};

export default DepositItem;
